export const SET_MODAL_CALLBACK = 'SET_MODAL_CALLBACK';
export const SET_CONFIRM_MODAL_VISIBLE = 'SET_CONFIRM_MODAL_VISIBLE';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';